"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const helperFunctions_1 = require("./helperFunctions");
// Initiate authentication using Google
exports.login = (sourceApp, baseurl, realm, tree, domain, name) => __awaiter(void 0, void 0, void 0, function* () {
    //Call API to submit sourceApp
    const sourceAppCallBack = yield helperFunctions_1.getAndSubmitSourceAppCallback(sourceApp, baseurl, realm, tree, name);
    //CallAPI to get Google redirect object
    const redirectObject = yield exports.getRedirectObject(sourceAppCallBack.response, baseurl, realm, tree, name);
    //Pull Google redirect URL from JSON
    const redirectGoogleUrl = helperFunctions_1.processRedirectObject(redirectObject);
    //Pull AuthId from JSON (needs to be sent back to AM later)
    const authId = helperFunctions_1.getAuthId(redirectObject);
    sessionStorage.setItem("AP_authId", authId);
    // setCookies("authId", authId, "/", domain);
    //Redirect user to Google sign in page
    helperFunctions_1.redirect(redirectGoogleUrl);
});
//Complete Google authentication after returning from Google sign in
exports.complete = (baseurl, realm, tree, domain, name) => __awaiter(void 0, void 0, void 0, function* () {
    //Get URL params from Google return url
    const urlParams = helperFunctions_1.getURLParams();
    //Add URL params to POST request url
    var url = baseurl + "/" + name + "/json" + realm + "/authenticate" + urlParams;
    //Parse state and code value from URL
    const splitParams = helperFunctions_1.parseURL(window.location.search);
    //Get authId value
    const authId = sessionStorage.AP_authId;
    sessionStorage.removeItem("AP_authId");
    // const cookieMap : StringMap = parseCookies(document.cookie);
    // delCookies("authId", cookieMap["authId"], "/", domain)
    const headers = {
        "Accept-API-Version": "resource=2.0",
        "Content-Type": "application/json"
    };
    const body = {
        "realm": realm,
        "authIndexType": "service",
        "authIndexValue": tree,
        "authId": authId,
        "state": splitParams["state"],
        "code": splitParams["code"],
        "scope": splitParams["scope"],
        "authuser": splitParams["authuser"],
        "prompt": splitParams["prompt"],
        "session_state": splitParams["session_state"]
    };
    return exports.finishGoogleAuth(url, headers, body);
});
exports.finishGoogleRegistration = (callback, mobileNumber, firstName, lastName, sourceApp, baseurl, realm, name) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json" + realm + "/authenticate";
    const headers = {
        "Accept-API-Version": "resource=2.1",
        "Content-Type": "application/json"
    };
    try {
        for (var i in callback.callbacks) {
            if (callback.callbacks[i].output[0].value === "Mobile Number") {
                callback.callbacks[i].input[0].value = mobileNumber;
            }
            else if (callback.callbacks[i].output[0].value === "First Name") {
                callback.callbacks[i].input[0].value = firstName;
            }
            else if (callback.callbacks[i].output[0].value === "Last Name") {
                callback.callbacks[i].input[0].value = lastName;
            }
            else if (callback.callbacks[i].output[0].value === "sourceApp") {
                callback.callbacks[i].input[0].value = sourceApp;
            }
        }
    }
    catch (err) {
        return {
            error: err
        };
    }
    const body = callback;
    return yield axios_1.default({
        data: body,
        method: 'post',
        headers,
        url
    })
        .then((resp) => {
        return {
            response: resp.data
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
// Complete Google registration after returning from Google sign in in which no account was found
// export const finishGoogleRegistration = async(callback: LoginPayloadSingle, mobileNumber: string, sourceApp: string, baseurl : string, realm : string, name : string) => {
//     const url : string = baseurl + "/" + name + "/json" + realm + "/authenticate";
//     const headers : StringMap = {
//         "Accept-API-Version": "resource=2.1",
//         "Content-Type": "application/json"
//     }
//     callback.callbacks[0].input[0].value = mobileNumber;
//     callback.callbacks[1].input[0].value = sourceApp;
//     const body : LoginPayloadSingle = callback
//     return await axios({
//         data: body,
//         method: 'post',
//         headers,
//         url
//     })
//     .then((resp) => {
//         return {
//             response: resp.data 
//         }
//     })
//     .catch((err) => {
//         return {
//             error: err
//         }
//     })
// }
//Complete Google authentication after returning from Google sign in
exports.finishGoogleAuth = (url, headers, body) => __awaiter(void 0, void 0, void 0, function* () {
    return yield axios_1.default({
        withCredentials: true,
        data: body,
        headers,
        method: "post",
        url,
    }).then(response => {
        return {
            response: response.data,
            status: response.status
        };
    })
        .catch(err => {
        return {
            response: err.response.data,
            status: err.response.status
        };
    });
});
//Call API for Google JSON response
exports.getRedirectObject = (data, baseurl, realm, tree, name) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + "/" + name + "/json" + realm + "/authenticate";
    const headers = {
        "Accept-API-Version": "resource=2.0",
        "Content-Type": "application/json"
    };
    const params = {
        "authIndexType": "service",
        "authIndexValue": tree
    };
    return yield axios_1.default({
        data: data,
        headers,
        method: "post",
        params,
        url
    }).then(response => {
        return {
            response: response.data,
            status: response.status
        };
    })
        .catch(err => {
        return {
            response: err.response.data,
            status: err.response.status
        };
    });
});
